import { render } from "./NewBedForm.vue?vue&type=template&id=5860414a&scoped=true"
import script from "./NewBedForm.vue?vue&type=script&lang=js"
export * from "./NewBedForm.vue?vue&type=script&lang=js"

import "./NewBedForm.vue?vue&type=style&index=0&id=5860414a&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5860414a"]])

export default __exports__